<script lang="ts">
  import { onMount } from "svelte";
  import { fetchToggles, patchToggles, ApiError } from "../lib/api";
  import { push } from "svelte-spa-router";
  import type { FeatureToggles } from "@diy-avatar/shared/admin";

  export let label: string | undefined = undefined;

  let toggles: FeatureToggles | null = null;
  let info: string | null = null;
  let error: string | null = null;
  let saving = false;

  async function load() {
    try {
      const res = await fetchToggles(label);
      toggles = res.toggles;
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        push("/");
        return;
      }
      error = err instanceof Error ? err.message : "load failed";
    }
  }

  async function save() {
    if (!toggles) return;
    saving = true;
    info = null;
    error = null;
    try {
      const res = await patchToggles(toggles, label);
      toggles = res.toggles;
      info = "saved";
    } catch (err) {
      error = err instanceof Error ? err.message : "save failed";
    } finally {
      saving = false;
    }
  }

  onMount(load);
</script>

<section>
  <h1>Feature toggles</h1>
  {#if error}
    <p class="error" data-testid="error">{error}</p>
  {/if}
  {#if toggles}
    <form on:submit|preventDefault={save}>
      <label>
        <input
          type="checkbox"
          bind:checked={toggles.text_mode}
          data-testid="text_mode"
        />
        Text mode
      </label>
      <label>
        <input
          type="checkbox"
          bind:checked={toggles.raise_hand}
          data-testid="raise_hand"
        />
        Raise hand
      </label>
      <label>
        <input
          type="checkbox"
          bind:checked={toggles.student_video}
          data-testid="student_video"
        />
        Student video
      </label>
      <label>
        <input
          type="checkbox"
          bind:checked={toggles.student_audio}
          data-testid="student_audio"
        />
        Student audio
      </label>
      <button type="submit" disabled={saving} data-testid="save">
        {saving ? "Saving…" : "Save"}
      </button>
      {#if info}<p class="info" data-testid="info">{info}</p>{/if}
    </form>
  {:else}
    <p>Loading…</p>
  {/if}
</section>

<style>
  h1 {
    margin: 0 0 1rem;
  }
  form {
    display: grid;
    gap: 0.5rem;
    max-width: 320px;
    background: #111827;
    border: 1px solid #1f2937;
    border-radius: 8px;
    padding: 1rem;
  }
  label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  button {
    padding: 0.5rem 0.8rem;
    background: #10b981;
    color: #04221a;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    justify-self: start;
  }
  .info {
    color: #6ee7b7;
  }
  .error {
    color: #fca5a5;
  }
</style>
